import request from '@/utils/request'

// 查询空间分页
export function pageSpace(data) {
  return request({
    url: '/space/space/page',
    method: 'post',
    data: data
  })
}

// 查询空间详情
export function getSpace(data) {
  return request({
    url: '/space/space/detail',
    method: 'post',
    data: data
  })
}

// 新增空间
export function addSpace(data) {
  return request({
    url: '/space/space/add',
    method: 'post',
    data: data
  })
}

// 修改空间
export function updateSpace(data) {
  return request({
    url: '/space/space/edit',
    method: 'post',
    data: data
  })
}

// 删除空间
export function delSpace(data) {
  return request({
    url: '/space/space/delete',
    method: 'post',
    data: data
  })
}

// 获取门类型列表
export function getDoorTypes() {
  return request({
    url: '/space/space/doorTypes',
    method: 'post'
  })
}
